export var SORTABLE_TYPE = 'SORTABLE_LIST';